import React from 'react'
import { cn } from '@/lib/utils'

interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'success' | 'warning' | 'error'
}

export function Badge({ className, variant = 'default', ...props }: BadgeProps) {
  return (
    <div
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors',
        variant === 'default' && 'bg-[var(--primary)]/10 text-[var(--primary)]',
        variant === 'success' && 'bg-green-500/10 text-green-600 dark:text-green-400',
        variant === 'warning' && 'bg-yellow-500/10 text-yellow-600 dark:text-yellow-400',
        variant === 'error' && 'bg-red-500/10 text-red-600 dark:text-red-400',
        className
      )}
      {...props}
    />
  )
}
